import { Grid, Button, Typography } from '@material-ui/core';
import { Page, Header, Content, InfoCard } from '@backstage/core-components';
import { Link as RouterLink } from 'react-router-dom';
import usecases from './usecases.json';

export const UseCasesPage = () => {
  return (
    <Page themeId="home">
      <Header title="Use Case Based Development" />
      <Content>
        <Grid container spacing={3}>
          {usecases.map(u => (
            <Grid item md={4} xs={12} key={u.id} style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ height: '280px', display: 'flex', flexDirection: 'column' }}>
                <InfoCard title={u.title}>
                  <div style={{ display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between' }}>
                    <div>
                      <Typography variant="body2" paragraph>
                        {`Use Case ${u.id} Development cards`}
                      </Typography>
                      
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        component={RouterLink}
                        to={`/catalog/use-cases/${u.id}`}
                      >
                        Open
                      </Button>
                    </div>
                  </div>
                </InfoCard>
              </div>
            </Grid>
          ))}
        </Grid>
      </Content>
    </Page>
  );
};

export default UseCasesPage;
